import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import enums from 'util/enums';

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: ['Package']
});

export const packagesApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listSigningPackages: build.query({
      async queryFn(args) {
        const {
          skip = 0,
          pageSize = 25,
          keyword = '',
          sortKey = '',
          sortOrderAsc = false
        } = args || {};

        const trimmedKeyword = (keyword || '').trim();
        const effectiveSortKey = sortKey || 'Created';
        const orderDirection =
          sortKey === 'SortOrder' || sortOrderAsc ? 'asc' : 'desc';

        const body = {
          MaxResults: pageSize,
          Skip: skip,
          OrderBy: effectiveSortKey,
          OrderDirection: orderDirection,
          IncludeData: false,
          IncludeSubordinates: true,
          ...(trimmedKeyword
            ? {
                Filters: {
                  Name: trimmedKeyword || ''
                }
              }
            : {})
        };

        try {
          const res = await api.Enumeration(
            enums.ENUMERATION_TYPES.DOCCOLL,
            body
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      keepUnusedDataFor: 60,
      providesTags: [{ type: 'Package', id: 'LIST' }]
    })
  })
});

export const { useListSigningPackagesQuery } = packagesApi;
